import { Row, SortableColumnHeading, ColumnHeading } from '@ui/kit';
import { nestedTHead } from './table.nested-thead.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { nestedRowSizingCls } from './table.nested-item.style.js';

function NestedTHead(props) {
  return /*#__PURE__*/jsxs(Row, {
    as: "header",
    className: nestedTHead,
    sizingCls: nestedRowSizingCls,
    children: [/*#__PURE__*/jsx(SortableColumnHeading, {
      active: props.options.sortBy === "studentName",
      direction: props.options.direction,
      onSort: () => props.onSort("studentName"),
      children: "Navn"
    }), /*#__PURE__*/jsx(SortableColumnHeading, {
      active: props.options.sortBy === "studentTeam",
      direction: props.options.direction,
      onSort: () => props.onSort("studentTeam"),
      children: "Klasse"
    }), /*#__PURE__*/jsx(SortableColumnHeading, {
      active: props.options.sortBy === "date",
      direction: props.options.direction,
      onSort: () => props.onSort("date"),
      children: "Dato"
    }), props.withStats && /*#__PURE__*/jsx(ColumnHeading, {
      children: "Statistik"
    }), /*#__PURE__*/jsx(ColumnHeading, {
      label: "Dialog"
    })]
  });
}

export { NestedTHead };
//# sourceMappingURL=table.nested-thead.js.map
